import React from "react";
import { Outlet } from "react-router-dom";

const OuterLayout = () => {
  return (
    <div className="container" style={{ height: "100%" }}>
      <Outlet />
    </div>
  );
};

export default OuterLayout;
